import { useGenerateDescriptionModel } from '@client/new/pages/creator/library/models/generateDescription.model';
import { useState } from 'react';

export type GenerateDescriptionViewModel = {
  name: string;
  bulletForm: boolean;
  concise: boolean;
  generatedDescription: string;
  setName: (value: string) => void;
  setConcise: (value: boolean) => void;
  setBulletForm: (value: boolean) => void;
  handleCreate: () => void;
};

export const useGenerateDescriptionVM = (): GenerateDescriptionViewModel => {
  const { generatedDescription, generate } = useGenerateDescriptionModel();

  const [name, setName] = useState<string>('');
  const [concise, setConcise] = useState<boolean>(false);
  const [bulletForm, setBulletForm] = useState<boolean>(true);

  const handleCreate = () => {
    generate({
      concise,
      exerciseName: name,
      bulletForm,
    });
  };

  return {
    name,
    concise,
    bulletForm,
    generatedDescription,
    setBulletForm,
    setConcise,
    setName,
    handleCreate,
  };
};
